import React, { useEffect, useState, useRef } from "react";
import { Progress } from "reactstrap";

const ProgressBar: React.FC<{ loading: boolean }> = ({ loading }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  
  // Reset progress and make visible when loading state changes to true
  useEffect(() => {
    if (loading) {
      setVisible(true);
      setProgress(0);
    }
  }, [loading]);
  
  useEffect(() => {
    // Clear any existing intervals when effect runs
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    
    if (loading) {
      intervalRef.current = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 50) {
            if (intervalRef.current) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
            }
            return 50;
          }
          return prevProgress + 5; // Increase progress slowly to 50
        });
      }, 50); // Adjust the interval time for slower or faster animation
    } else {
      // Only run this if previously visible (loading was true)
      if (visible) {
        intervalRef.current = setInterval(() => {
          setProgress((prevProgress) => {
            if (prevProgress >= 100) {
              if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
              }
              setTimeout(() => setVisible(false), 500); // Hide after a short delay
              return 100;
            }
            return prevProgress + 10; // Increase progress quickly to 100
          });
        }, 50);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Cleanup interval on component unmount
      }
    };
  }, [loading, visible]);

  // Don't render anything if not visible
  if (!visible) return null;

  return (
    <Progress
      animated
      className="!rounded-none !h-[5px]"
      value={progress}
    />
  );
};

export default React.memo(ProgressBar);
